(function(){
  'use strict';
  const menu=document.getElementById('ov2-menu');
  const toggle=document.getElementById('ov2-menu-toggle');
  const header=document.getElementById('ov2-header');
  if(menu&&toggle){
    const setMenu=(open)=>{
      menu.classList.toggle('is-open',open);
      toggle.classList.toggle('is-open',open);
      toggle.setAttribute('aria-expanded',String(open));
      toggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');
      menu.setAttribute('aria-hidden',String(!open));
      if('inert' in menu) menu.inert=!open;
      document.body.classList.toggle('ov2-menu-open',open);
      if(open){menu.querySelector('a')?.focus();}
      else {toggle.focus({preventScroll:true});}
    };
    if('inert' in menu) menu.inert=true;
    toggle.addEventListener('click',()=>setMenu(!menu.classList.contains('is-open')));
    menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMenu(false)));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.classList.contains('is-open'))setMenu(false);});
  }
  const prefersReduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const stage=document.querySelector('[data-ov2-product-view]');
  if(stage){
    let isBack=false,down=null;
    const flip=(back)=>{
      isBack=back;stage.classList.toggle('is-back',isBack);
      const status=document.querySelector('[data-ov2-side-text]');if(status)status.textContent=isBack?'BACK / 02':'FRONT / 01';
    };
    document.querySelectorAll('[data-ov2-side]').forEach(b=>b.addEventListener('click',()=>flip(b.dataset.ov2Side==='back')));
    stage.addEventListener('click',()=>{if(stage.dataset.preventClick==='1')return;flip(!isBack);});
    stage.addEventListener('pointerdown',e=>{down={x:e.clientX,t:Date.now()};});
    stage.addEventListener('pointerup',e=>{if(!down)return;const distance=e.clientX-down.x;if(Math.abs(distance)>35){flip(distance<0);stage.dataset.preventClick='1';setTimeout(()=>{stage.dataset.preventClick='0'},300);}down=null;});
    stage.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();flip(true);}if(e.key==='ArrowLeft'){e.preventDefault();flip(false);}});
    // A small perspective response, no external library, disabled when motion is reduced.
    if(!prefersReduced.matches&&window.matchMedia('(pointer:fine)').matches){
      stage.addEventListener('pointermove',e=>{const r=stage.getBoundingClientRect();const x=((e.clientX-r.left)/r.width-.5);const y=((e.clientY-r.top)/r.height-.5);stage.style.setProperty('--ov2-tilt-x',(-7*y).toFixed(2)+'deg');stage.style.setProperty('--ov2-tilt-y',(9*x).toFixed(2)+'deg');});
      stage.addEventListener('pointerleave',()=>{stage.style.setProperty('--ov2-tilt-x','0deg');stage.style.setProperty('--ov2-tilt-y','0deg');});
    }
  }
  if('IntersectionObserver' in window){
    const io=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('ov2-in-view');io.unobserve(e.target);}})},{threshold:.12,rootMargin:'0px 0px -25px 0px'});
    document.querySelectorAll('.ov2-reveal').forEach(e=>io.observe(e));
  } else document.querySelectorAll('.ov2-reveal').forEach(e=>e.classList.add('ov2-in-view'));
  let raf=false;
  const onScroll=()=>{if(raf)return;raf=true;requestAnimationFrame(()=>{const y=window.scrollY||0;if(header)header.classList.toggle('is-scrolled',y>15);const hero=document.getElementById('ov2-hero');if(hero&&!prefersReduced.matches){let p=Math.min(1,Math.max(0,y/Math.max(1,hero.offsetHeight)));hero.style.setProperty('--scroll',p.toFixed(3));hero.style.setProperty('--ov2-offset',(-p*38).toFixed(1)+'px');}raf=false;});};
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  const variant=document.querySelector('[data-ov2-variants]');
  if(variant){const price=document.querySelector('[data-ov2-price]');const add=document.querySelector('[data-ov2-add]');const onChange=()=>{const opt=variant.selectedOptions[0];if(price&&opt.dataset.price)price.textContent=opt.dataset.price;if(add){add.disabled=opt.dataset.available==='false';add.textContent=add.disabled?'SOLD OUT':'ADD TO BAG ↗';}};variant.addEventListener('change',onChange);onChange();}
})();

